import store from "@/store";

export default {
    props: {
        isCollapse: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        identity() {
            return this.$store.state.identity
        }
    },
    methods: {
        // 核心：处理学期点击，传递值到Vuex
    handleXueQiClick(xueQi) {
                //(xueQi);
            // 向根模块存值（根模块的mutation无需加模块名）
            this.$store.commit('setXueQi', xueQi); 
            // 跳转到worksuser页面
            this.setPage('worksuser');
     },
        setPage(pagename) {
              this.$store.commit('resetName');
            store.commit('page/setPage',pagename)
            // 新增：重置搜索框（调用Vuex的resetName）
           
            
        },
        changeDialogFormVisible(visible) {
            
            store.commit('setDialogFormVisible', visible); 
             this.$store.commit('resetName');
        },
        changWorksStatus(status) {
            store.commit('setWorksStatus', status); 
            this.$store.commit('resetName');
        },
        systemMaintenance() {
            console.log('执行系统维护操作');
            this.$store.commit('resetName');
        },
        dataBackup() {
            console.log('执行数据备份操作');
            this.$store.commit('resetName');
        }
    },
}